import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext } from 'react-hook-form';
import isEmpty from 'lodash/isEmpty';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';
import Paper from '@material-ui/core/Paper';
import { Search } from 'components/Search/Search';
import { axiosInstance } from '../../axiosInstance';

const Groups = () => {
  const { t } = useTranslation();
  const { control, watch, setValue } = useFormContext();
  const [usersGroups, setUsersGroups] = useState([]);
  const watchUserGroups = watch('user_groups');
  const [checkedValues, setCheckedValues] = useState<string[]>([]);

  useEffect(() => {
    setCheckedValues(watchUserGroups || []);
  }, []);

  const handleSelect = (checkedName: string) => {
    const newNames = checkedValues?.includes(checkedName)
      ? checkedValues?.filter((name: string) => name !== checkedName)
      : [...(checkedValues ?? []), checkedName];
    setCheckedValues(newNames);

    return newNames;
  };

  const getUsers = useCallback(async (page: number, searchTerm?: string) => {
    const {
      data: { user_groups }
    } = await axiosInstance.get('/acls/user-groups', { params: { index: page, size: 30, search: searchTerm } });
    setUsersGroups(user_groups);
  }, []);

  useEffect(() => {
    const onLoad = async () => {
      await getUsers(1);
    };
    onLoad();
  }, []);

  return (
    <>
      <div style={{ margin: '50px 0 15px' }}>
        <h5>{t('acl.users groups')}</h5>
      </div>
      {!isEmpty(usersGroups) && (
        <div style={{ marginBottom: '15px' }}>
          <Search
            resetFunction={() => getUsers(1)}
            searchFunction={(st: string) => getUsers(1, st)}
            searchLabel="user_group"
          />
        </div>
      )}
      <TableContainer component={Paper} elevation={3} style={{ maxHeight: '50vh', height: '100%' }}>
        <Table stickyHeader aria-label="order list">
          <TableHead>
            <TableRow>
              <TableCell>{t('acl.user group')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {usersGroups.map(({ id, name }) => (
              <TableRow
                key={id}
                hover
                onClick={() => {
                  setValue('actions', handleSelect(id));
                }}
                style={{ cursor: 'pointer' }}
              >
                <TableCell>
                  <Controller
                    name="user_groups"
                    control={control}
                    render={({ onChange: onCheckChange }) => (
                      <Checkbox
                        checked={checkedValues.includes(id)}
                        onClick={e => e.stopPropagation()}
                        onChange={e => {
                          e.stopPropagation();
                          onCheckChange(handleSelect(id));
                        }}
                      />
                    )}
                  />
                  {name}
                </TableCell>
              </TableRow>
            ))}
            {isEmpty(usersGroups) && (
              <TableRow>
                <TableCell align="center">{t(`acl.user_group.no data`)}</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export { Groups };
